function toggleShowHideFilters(e, dropdown) {
  const formFields = dropdown.querySelector('.form-fields');
  const showHideButton = e.target;

  if (formFields.classList.contains('show')) {
    formFields.classList.remove('show');
    showHideButton.textContent = 'Show More Filters';
  } else {
    formFields.classList.add('show');
    showHideButton.textContent = 'Show Less Filters';
  }
}

function getFilterDetails(dropdown) {
  const filterSelection = Array.from(
    dropdown.querySelectorAll('.filter-option:checked')
  );
  const filterToggle = dropdown.querySelector('.dropdown-toggle');
  const filterToggleText = filterToggle.querySelector('.btn-text');
  const filterId = filterToggle.id;
  const filterValueInput = dropdown.querySelector(`#${filterId}-value`);

  return {
    filterSelection,
    filterToggle,
    filterToggleText,
    filterId,
    filterValueInput,
  };
}

function resetFilters(e, dropdown) {
  const { filterSelection } = getFilterDetails(dropdown);
  filterSelection.forEach((input) => {
    // Using click instead of falsy assignment here so the change event gets triggered.
    input.click();
  });
}

function formatFilterSelection(filterSelection) {
  let filterSelectionValues = [];
  let formattedFilterSelectionValues = '';

  if (filterSelection.length > 0) {
    filterSelection.forEach((input) => filterSelectionValues.push(input.value));
    formattedFilterSelectionValues = filterSelectionValues
      .sort((a, b) => b - a)
      .join(', ');
  }

  return formattedFilterSelectionValues;
}

function updateFilterValue(dropdown) {
  const { filterSelection, filterToggle, filterToggleText, filterValueInput } =
    getFilterDetails(dropdown);

  if (filterSelection.length > 0) {
    filterValueInput.value = formatFilterSelection(filterSelection);
    filterToggle.dataset.text = formatFilterSelection(filterSelection);
    // filterToggleText.textContent = formatFilterSelection(filterSelection);
    filterToggleText.textContent = 'Publication Date';
    filterToggle.dataset.hasValue = true;
  } else {
    filterValueInput.value = '';
    filterToggle.dataset.text = '';
    filterToggleText.textContent = filterToggleText.offsetParent.dataset.field;
    filterToggle.dataset.hasValue = false;
  }

  // Trigger an event on update
  filterValueInput.dispatchEvent(new Event('change'));
}

export function initializeFilterDropdown() {
  const filterDropdowns = [
    ...document.querySelectorAll('.filter-dropdown'),
    ...document.querySelectorAll('.catalog-filter-dropdown'),
  ];

  filterDropdowns.forEach((filterDropdown) => {
    updateFilterValue(filterDropdown);

    const toggleFiltersBtn = filterDropdown.querySelector('.toggle-filters');
    if (toggleFiltersBtn) {
      toggleFiltersBtn.addEventListener('click', (e) => {
        toggleShowHideFilters(e, filterDropdown);
      });
    }

    const resetFiltersBtn = filterDropdown.querySelector('.reset-filters');
    if (resetFiltersBtn) {
      resetFiltersBtn.addEventListener('click', (e) =>
        resetFilters(e, filterDropdown)
      );
    }

    const filterOptions = Array.from(
      filterDropdown.querySelectorAll('.filter-option')
    );
    filterOptions.forEach((filter) => {
      filter.addEventListener('change', () =>
        updateFilterValue(filterDropdown)
      );
    });
  });
}
